﻿window.cBuilderEmailWidgetCtrlAdrPostale = function cBuilderEmailWidgetCtrlAdrPostale(option) {
    var Me = this;

    // =========================================================
    // Héritage
    // =========================================================

    window.cBuilderEmailWidgetCtrl.call(this, option);


    // =========================================================
    // Propriétés spécifiques
    // =========================================================

    this.nomWidget = "dxwidgetformadrpostale"
    this.icone = "fas fa-map-location-dot";
    this.nomBt = "Adresse postale";
    this.titleBt = "Saisie adresse postale"
    this.labelCtrl = "Adresse postale"
    this.typeDevExpress = "dxCtrlSaisieAdresse"


    // =========================================================
    // Surcharge mCreateElement
    // =========================================================

    var mCreateElementParent = this.mCreateElement;

    this.mCreateElement = function () {

        // Appel de la méthode du parent
        mCreateElementParent.call(Me);

        // =====================================================
        // AJOUT PERSONNEL DE LA CLASSE FILLE
        // =====================================================

        var $Td = Me.mGetTdSaisie();

        Me.mAddCtrlDevExpress()
    };

    this.mAddCtrlDevExpress = function (onValueChangedDevexpress) {
        Me.mGetTdSaisie().empty()
        var ctrl = $("<div class='ctrldevexpress " + Me.mGetTypeCtrlDevexpress() + " electrl" + Me.mGetIndexdevexpress() + " " + (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "obligatoire" : "") + "'/>").appendTo(Me.mGetTdSaisie()).dxCtrlSaisieAdresse({
            label: (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "* " : "") + Me.mGetTdSaisie().attr("label"),
            labelMode: "floating",
            stylingMode: "outlined", //pour voir la bordure
            bddCtrl: option.bddCtrl,
            hideButton: true,
            onValueChanged: function (value) {
                ctrl.element().css("background-color", "")
                ctrl.element().closest("td").css("border-left", "")
                if (onValueChangedDevexpress) onValueChangedDevexpress(ctrl, Me.mGetTdSaisie().attr("indexdevexpress"), Me.mGetTdSaisie().attr("tri"), Me.mGetTdSaisie().attr("typedevexpress"), "", Me.mGetTdSaisie().attr("typchamp"), Me.mGetTdSaisie().attr("label"), value)
            }
        }).dxCtrlTextEmail("instance")
        ctrl.isEmpty = function () {
            return !ctrl.hasValue()
        }
        return ctrl
    }


    // =========================================================
    // Surcharge mAddCtrlSaisie
    // =========================================================

    var mAddCtrlSaisieParent = this.mAddCtrlSaisie;

    this.mAddCtrlSaisie = function (contentElement) {

        // Appel de la méthode du parent
        mAddCtrlSaisieParent.call(Me, contentElement);
    };
};